module.exports = __webpack_public_path__ + "img/carVin.8586c66b.png";